const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-139"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.78,
    y: 251.67,
    width: 35.1,
    height: 130.73,
    transform: "translate(570.66 634.07) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.62 382.4 267.78 382.4 267.78 370.63 279.75 370.63 273.62 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.64,
    y: 251.67,
    width: 35.1,
    height: 130.73,
    transform: "translate(856.38 634.07) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.78,
    y: 251.67,
    width: 147.96,
    height: 126.21,
    transform: "translate(683.52 629.55) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.31,
    y: 257.26,
    width: 138.89,
    height: 34.61,
    transform: "translate(683.52 549.13) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,268h13.12c5.7,0,11.15-4.27,15.07-11.81H320.13C324.05,263.75,329.5,268,335.2,268Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.9 382.4 415.74 382.4 415.74 370.63 403.77 370.63 409.9 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.31,
    y: 297.47,
    width: 138.89,
    height: 34.61,
    transform: "translate(683.52 629.55) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,308.22h13.12c5.7,0,11.15-4.27,15.07-11.81H320.13C324.05,304,329.5,308.22,335.2,308.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.31,
    y: 337.67,
    width: 138.89,
    height: 34.61,
    transform: "translate(683.52 709.96) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,348.43h13.12c5.7,0,11.15-4.27,15.07-11.81H320.13C324.05,344.16,329.5,348.43,335.2,348.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 86.38,
    width: 134.04,
    height: 135.63,
    transform: "translate(290.03 308.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.69,
    y: 86.38,
    width: 140.88,
    height: 135.63,
    transform: "translate(278.25 308.4) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.11,
    y: 95.56,
    width: 112.03,
    height: 117.27,
    transform: "translate(293.33 15.08) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.32,113,116.8,134.56a27.81,27.81,0,0,0,0,39.28l21.52,21.53a1.13,1.13,0,0,0,1.6,0l21.53-21.53a27.81,27.81,0,0,0,0-39.28L139.93,113A1.15,1.15,0,0,0,138.32,113Zm-19.92,59.2a25.54,25.54,0,0,1,0-36.07Zm41.45,0V136.17A25.54,25.54,0,0,1,159.85,172.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.85 205 331.96 205 327.69 249.22 402.58 249.22 406.85 205",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.58 249.22 402.28 251.67 327.38 251.67 327.69 249.22 402.58 249.22",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.55 205 329.66 205 325.38 249.22 400.27 249.22 404.55 205",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76,246.34,401.89,208a.94.94,0,0,0-.93-1H332.11a.94.94,0,0,0-.94.86L328,246.19a.94.94,0,0,0,.94,1h68.85A.93.93,0,0,0,398.76,246.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.76 249.22 380.46 251.67 297.99 251.67 298.29 249.22 380.76 249.22",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.09,
    y: 87.88,
    width: 140.63,
    height: 93.49,
    transform: "translate(700.81 269.24) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 87.88,
    width: 140.63,
    height: 93.49,
    transform: "translate(694.56 269.24) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.84,
    y: 69.91,
    width: 80.88,
    height: 129.41,
    transform: "translate(481.9 -212.66) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.31,
    y: 133.44,
    width: 80.88,
    height: 2.36,
    transform: "translate(418.37 -149.14) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.28,
    y: 155.87,
    width: 135.99,
    height: 8.46,
    transform: "translate(694.56 320.2) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.85,77.45h156a.87.87,0,0,1,.86.86h0a.86.86,0,0,1-.86.86h-156a.86.86,0,0,1-.87-.86h0A.87.87,0,0,1,270.85,77.45Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,78.31A2.16,2.16,0,1,0,270,76.15,2.16,2.16,0,0,0,267.83,78.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.55,83.15h0A1.17,1.17,0,0,0,420.72,82v-2.5a1.17,1.17,0,0,0-1.17-1.17h0a1.16,1.16,0,0,0-1.16,1.17V82A1.17,1.17,0,0,0,419.55,83.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.87,83.15h0A1.18,1.18,0,0,0,285,82v-2.5a1.17,1.17,0,0,0-1.17-1.17h0a1.16,1.16,0,0,0-1.16,1.17V82A1.17,1.17,0,0,0,283.87,83.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.12,
    y: 78.31,
    width: 144.15,
    height: 90.83,
    transform: "translate(686.4 247.45) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.51,78.31a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,403.51,78.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 275.65,
    width: 11.56,
    height: 100.27,
    transform: "translate(410.56 651.57) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.1,
    y: 375.92,
    width: 132.52,
    height: 6.35,
    transform: "translate(280.72 758.19) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.66,
    y: 275.65,
    width: 129.84,
    height: 100.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.75,
    y: 287.99,
    width: 111.66,
    height: 32.88,
    rx: 7.12,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.75,
    y: 330.69,
    width: 111.66,
    height: 32.88,
    rx: 7.12,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,306.69h48.38a2.26,2.26,0,0,0,2.26-2.25h0a2.27,2.27,0,0,0-2.26-2.26H110.39a2.27,2.27,0,0,0-2.26,2.26h0A2.26,2.26,0,0,0,110.39,306.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,349.39h48.38a2.26,2.26,0,0,0,2.26-2.25h0a2.27,2.27,0,0,0-2.26-2.26H110.39a2.27,2.27,0,0,0-2.26,2.26h0A2.26,2.26,0,0,0,110.39,349.39Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-139"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-139",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Survey--inject-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292.85 101.45 108.05 101.45 122.41 353.12 307.2 353.12 292.85 101.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.44 101.45 111.64 101.45 126 353.12 310.8 353.12 296.44 101.45",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.71,109.91H120.09l11.73,227.81H299.69Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,109.91c12.16,75.94,3.82,151.88,16,227.81H303.94c-12.16-75.93-3.82-151.87-16-227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.41,178.17A14.47,14.47,0,0,1,168.75,192a13.14,13.14,0,0,1-13.26,13.69,14.34,14.34,0,0,1-14.21-13.77,13.23,13.23,0,0,1,3.63-9.69,13.05,13.05,0,0,1,9.5-4m-.1-2.89a15.85,15.85,0,0,0-15.93,16.63,17.31,17.31,0,0,0,17.15,16.63,16,16,0,0,0,16.12-16.63,17.47,17.47,0,0,0-17.34-16.63Z",
    style: {
      fill: "#ADB793"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,302.92h-53a2.79,2.79,0,0,0-2.82,3.1h0a3.51,3.51,0,0,0,3.41,3.11h53a2.77,2.77,0,0,0,2.8-3.11h0A3.49,3.49,0,0,0,247.22,302.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,289.87H193.15a2.83,2.83,0,0,0-2.87,3.1h0a3.4,3.4,0,0,0,3.34,3.11H276A2.83,2.83,0,0,0,278.9,293h0A3.39,3.39,0,0,0,275.57,289.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.1,232a14.26,14.26,0,0,1,14.15,13.77,13.26,13.26,0,0,1-3.69,9.69,13.1,13.1,0,0,1-9.54,4,14.35,14.35,0,0,1-14.24-13.77A13.24,13.24,0,0,1,156.1,232m0-2.9h0a16.09,16.09,0,0,0-16.18,16.63,17.33,17.33,0,0,0,17.22,16.64,16,16,0,0,0,16.05-16.64,17.21,17.21,0,0,0-17.09-16.63Z",
    style: {
      fill: "#ADB793"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,188.49H189.45a3.25,3.25,0,0,1-3.22-3.11h0a3,3,0,0,1,3-3.1h28.34a3.27,3.27,0,0,1,3.24,3.1h0A3,3,0,0,1,217.8,188.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.52,188.49h-19.2a3.26,3.26,0,0,1-3.23-3.11h0a3,3,0,0,1,3-3.1h19.21a3.26,3.26,0,0,1,3.23,3.1h0A3,3,0,0,1,250.52,188.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,201.54H189.9a3.23,3.23,0,0,1-3.21-3.11h0a3,3,0,0,1,3-3.1h76.09a3.22,3.22,0,0,1,3.2,3.1h0A3,3,0,0,1,266,201.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.27,285.76a15.16,15.16,0,0,1,14.8,13.78,12.65,12.65,0,0,1-3.11,9.68,12.21,12.21,0,0,1-9.26,4,15.44,15.44,0,0,1-15.1-13.77,12.48,12.48,0,0,1,3.26-9.69,12.66,12.66,0,0,1,9.41-4m-.14-2.89A15.2,15.2,0,0,0,142.7,299.5c.77,9.18,9.1,16.63,18.28,16.63s15.76-7.45,15-16.63a18.24,18.24,0,0,0-17.84-16.63Z",
    style: {
      fill: "#ADB793"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279,249.13H191.19a3,3,0,0,0-3,3.1h0a3.24,3.24,0,0,0,3.21,3.1h87.85a3,3,0,0,0,3-3.1h0A3.22,3.22,0,0,0,279,249.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.19,236.07H190.81a3,3,0,0,0-3,3.11h0a3.21,3.21,0,0,0,3.19,3.1h67.39a3,3,0,0,0,3-3.1h0A3.2,3.2,0,0,0,258.19,236.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,201.72l-1.18-1.94c-2.59-4.23-8-8-9.86-9.11l1.4-2.48a38.24,38.24,0,0,1,9.68,8.36c4.25-5.71,10.46-11.58,18.87-17.92l1.81,2.34c-9,6.77-15.38,13-19.47,18.93C156.77,200.51,156.35,201.12,155.93,201.72Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,255.52c-.39-.65-.79-1.3-1.19-1.94-2.6-4.23-8-8-9.84-9.12l1.42-2.48a38.34,38.34,0,0,1,9.63,8.36c4.26-5.7,10.52-11.58,19.06-17.92l1.77,2.34c-9.12,6.77-15.54,13-19.61,18.93Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.86,309.44l-1.32-1.94c-2.88-4.23-8.46-8-10.38-9.11l1.3-2.48a42.05,42.05,0,0,1,10.09,8.35c3.92-5.7,9.88-11.58,18.16-17.91l1.87,2.34c-8.84,6.77-14.91,13-18.6,18.93Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.1,129q-2.64,5.76-5.41,11.51a24.75,24.75,0,0,1,13.64,20.08h13.29C244.74,147,236,135.17,224.1,129Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.47,160.61h13.29A21.17,21.17,0,0,1,196,141.24q-3.88-5.76-7.88-11.52C178.42,136,172.62,147.51,173.47,160.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,124.54a32.74,32.74,0,0,0-18,5.18q4,5.76,7.88,11.52a21,21,0,0,1,11.66-3.42,24.25,24.25,0,0,1,11,2.71q2.76-5.76,5.41-11.51A39.2,39.2,0,0,0,206.12,124.54Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,124.54a32.74,32.74,0,0,0-18,5.18q4,5.76,7.88,11.52a21,21,0,0,1,11.66-3.42,24.25,24.25,0,0,1,11,2.71q2.76-5.76,5.41-11.51A39.2,39.2,0,0,0,206.12,124.54Z",
    style: {
      fill: "#263238",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.36,151.51S208.94,157,207.52,158a3.19,3.19,0,0,0-.57,4.53,3.35,3.35,0,0,0,4.58.87C213,162.34,222.38,151.51,222.36,151.51Zm-14.1,10a1.57,1.57,0,0,1,.28-2.23,1.67,1.67,0,0,1,2.26.43,1.57,1.57,0,0,1-.28,2.23A1.67,1.67,0,0,1,208.26,161.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.27,145.16a4.26,4.26,0,0,1-4.32,4.72,5.25,5.25,0,0,1-5.12-4.72,4.23,4.23,0,0,1,4.28-4.71A5.28,5.28,0,0,1,238.27,145.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,144.08a.68.68,0,0,1-.68.75.83.83,0,0,1-.82-.75.67.67,0,0,1,.68-.75A.83.83,0,0,1,232.42,144.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,144.08a.68.68,0,0,1-.69.75.85.85,0,0,1-.82-.75.67.67,0,0,1,.69-.75A.83.83,0,0,1,236,144.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.77,148h0a4,4,0,0,1-2.67-1.05.37.37,0,0,1,0-.52.36.36,0,0,1,.52,0,3.25,3.25,0,0,0,2.17.86h0a2.66,2.66,0,0,0,2-.84.37.37,0,1,1,.54.51A3.38,3.38,0,0,1,233.77,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.62,131.1a4.15,4.15,0,0,1-4.2,4.72,5.41,5.41,0,0,1-5.24-4.72,4.1,4.1,0,0,1,4.16-4.71A5.46,5.46,0,0,1,211.62,131.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74,130a.66.66,0,0,1-.66.75.87.87,0,0,1-.84-.75.65.65,0,0,1,.66-.75A.86.86,0,0,1,205.74,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.31,130a.66.66,0,0,1-.67.75.88.88,0,0,1-.84-.75.66.66,0,0,1,.67-.75A.87.87,0,0,1,209.31,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.41,133h-4.68a.38.38,0,0,1,0-.75h4.68a.38.38,0,0,1,0,.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.87,145.16a4.26,4.26,0,0,1-4.32,4.72,5.25,5.25,0,0,1-5.12-4.72,4.23,4.23,0,0,1,4.28-4.71A5.29,5.29,0,0,1,187.87,145.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,144.08a.68.68,0,0,1-.68.75.83.83,0,0,1-.82-.75.67.67,0,0,1,.68-.75A.83.83,0,0,1,182,144.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,144.08a.67.67,0,0,1-.68.75.85.85,0,0,1-.82-.75.67.67,0,0,1,.68-.75A.82.82,0,0,1,185.58,144.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,148a.35.35,0,0,1-.25-.1.37.37,0,0,1,0-.52,3.43,3.43,0,0,1,2.53-1.08,4,4,0,0,1,2.67,1.06.36.36,0,0,1,0,.52.39.39,0,0,1-.53,0,3.2,3.2,0,0,0-2.18-.86,2.68,2.68,0,0,0-2,.83A.39.39,0,0,1,181,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,110.56c-3.12-6.57-10.4-10.92-18.25-10.92h-16a6.24,6.24,0,0,1-5.55-2.9c-2.23-4.18-7.55-7.16-13.59-7.16s-11,3-12.76,7.16c-.73,1.76-2.82,2.9-5.22,2.9h-16c-7.85,0-14.64,4.35-17,10.92a1.62,1.62,0,0,0-.1.72,2,2,0,0,0,2,1.9H255.15A1.79,1.79,0,0,0,256.74,110.56ZM204,101.45A4.78,4.78,0,0,1,199.33,97a4.16,4.16,0,0,1,4.2-4.45A4.77,4.77,0,0,1,208.24,97,4.16,4.16,0,0,1,204,101.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.42,409.11a3.2,3.2,0,0,1-2.22-.55.69.69,0,0,1-.07-.76.74.74,0,0,1,.51-.41c1.18-.33,3.91,1.13,4,1.2a.17.17,0,0,1,.1.18.15.15,0,0,1-.12.14A12.92,12.92,0,0,1,360.42,409.11Zm-1.32-1.42a1.11,1.11,0,0,0-.33,0,.45.45,0,0,0-.32.24c-.1.22,0,.33,0,.39.4.47,2.26.48,3.6.29A8.65,8.65,0,0,0,359.1,407.69Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.62,408.91h-.07c-.93-.4-2.87-2-2.83-2.82,0-.2.12-.44.6-.49a1.42,1.42,0,0,1,1,.3,5.65,5.65,0,0,1,1.46,2.83.18.18,0,0,1,0,.16A.17.17,0,0,1,362.62,408.91Zm-2.13-3h-.1c-.31,0-.32.15-.32.19,0,.5,1.31,1.75,2.28,2.29a4.66,4.66,0,0,0-1.23-2.26A1,1,0,0,0,360.49,405.93Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.68 408.74 363.33 408.74 360.7 391.72 368.05 391.72 370.68 408.74",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.28,407.89h8a.74.74,0,0,1,.68.5l2.18,6.53a1,1,0,0,1-.91,1.3c-2.9,0-7.1-.21-10.74-.21-4.25,0-3.87.23-8.86.23-3,0-4.19-3.05-3-3.33,5.61-1.25,6.26-1.39,10.88-4.45A3.09,3.09,0,0,1,363.28,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.7 391.73 362.06 400.5 369.41 400.5 368.05 391.73 360.7 391.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,225.45l-5,5.05,7.66,2.71s3-4.12.89-6.94Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.16 237.56 370.81 238.68 372.52 233.21 364.86 230.5 363.16 237.56",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.18,163.27c.65,1.4,1.17,2.59,1.69,3.89s1,2.55,1.5,3.83c.95,2.57,1.8,5.19,2.59,7.84a82.8,82.8,0,0,1,2,8.15l.38,2.1.31,2.14c.11.71.18,1.45.24,2.18s.16,1.39.16,2.31l0,1.3,0,1.15-.06,1.13-.11,1.07c-.13,1.44-.32,2.79-.5,4.16-.4,2.7-.86,5.34-1.37,8-1.06,5.23-2.22,10.34-3.62,15.49l-9.11-1.8c.58-5.08,1.18-10.24,1.66-15.32.23-2.54.48-5.07.62-7.55.06-1.22.13-2.46.13-3.63v-.88l0-.81,0-.81-.07-.66a15,15,0,0,0-.22-1.57c-.09-.56-.17-1.12-.3-1.69l-.37-1.71-.43-1.72c-.62-2.3-1.32-4.61-2.12-6.92s-1.69-4.61-2.63-6.89c-.46-1.15-.94-2.29-1.44-3.41s-1-2.29-1.49-3.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,221.87s1.22,56.24,4.52,78.64c3.44,23.3,16,98.29,16,98.29h12.44s-4.46-71.37-5.88-94.3c-1.55-25-1.21-82.63-1.21-82.63Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.18,393.84c-.06,0,1.28,5.17,1.28,5.17H372.6l-.11-4.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.11,
    cy: 130.65,
    rx: 1.13,
    ry: 0.74,
    transform: "translate(184.13 457.11) rotate(-86.48)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.54,131.78a23.2,23.2,0,0,1-3.16,5.32,3.52,3.52,0,0,0,2.95.56Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18,127.2a.43.43,0,0,1-.22-.06,2.82,2.82,0,0,0-2.57-.48.36.36,0,0,1-.47-.21.37.37,0,0,1,.23-.47,3.55,3.55,0,0,1,3.26.56.37.37,0,0,1,.07.51A.38.38,0,0,1,338.18,127.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.3,137.52c-1.24,5.38-2.64,15.23,1,18.81,0,0-1.66,5.45-11.65,5.45-11,0-5.05-5.45-5.05-5.45,6-1.43,6.05-5.87,5.15-10.05Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.17,158.85c1.08-2.19,2.27-4.71,0-5.49-2.48-.87-16.19-1.75-21-.13a5,5,0,0,0-3.61,6.08Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,158.44c6.33,2.92,9.55,25.06,9.55,25.06l-12.75,4a129.49,129.49,0,0,1-5.53-18C360,160.26,364.21,155.46,370.69,158.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.33,192.89l-5.88-5.06-5.29,7.7s4.75,3.81,10,2.25Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.7 185.38 277.89 192.99 281.16 195.53 286.45 187.83 278.7 185.38",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.65,129.33c-.74,7.64-.79,12.14-4.79,16.06A10,10,0,0,1,335,140.16c-1.4-6.86,0-18.2,7.63-21.24A10.09,10.09,0,0,1,356.65,129.33Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,131.78c-.67-5.28-.56-7.28,2.26-8.45-2.93-.58-5.47-.66-6.68-2.37s-1.5-6.08,4.38-8.08c-.54,1,1.17,3.08,6.58,1.2s13.29-2.08,14,3.42c2.86-1,7.65,7.83,2,14.28-4.71,5.4-7.85,9.13-8.78,12a1,1,0,0,1-1.37.6c-1.95-.91-5.44-.13-7,.29a1,1,0,0,1-1.14-.51C344.24,142.08,341.51,136.14,341,131.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.48,118.17s2.32-3.27,6.77-.84A20.16,20.16,0,0,0,360.48,118.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.86,118.87s3.23-2,.71-5.77A14.53,14.53,0,0,1,360.86,118.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.74,132a9.15,9.15,0,0,1-2.68,4.95c-1.85,1.75-3.45.51-3.5-1.74-.05-2,.85-5.38,3-6.28S345.12,129.74,344.74,132Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.68,253.12c.72,16.78,1.85,36.26,3.49,47.39.63,4.24,1.55,10.18,2.65,17.07C350.24,293.46,352.88,262.38,339.68,253.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.17,409.11c-.94,0-1.85-.13-2.14-.55a.68.68,0,0,1,0-.76,1,1,0,0,1,.57-.41c1.23-.33,3.75,1.13,3.86,1.2a.15.15,0,0,1,.07.18.18.18,0,0,1-.14.14A13.43,13.43,0,0,1,334.17,409.11Zm-1.11-1.42a1.18,1.18,0,0,0-.34,0,.53.53,0,0,0-.35.24c-.13.22-.09.33-.05.39.33.47,2.18.48,3.56.29A7.61,7.61,0,0,0,333.06,407.69Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,408.91h-.07c-.87-.4-2.58-2-2.41-2.82,0-.2.18-.44.66-.49a1.29,1.29,0,0,1,1,.3c.91.77,1,2.75,1,2.83a.21.21,0,0,1-.08.16A.19.19,0,0,1,336.4,408.91Zm-1.69-3h-.1c-.32,0-.34.15-.35.19-.1.5,1.05,1.75,1.94,2.29a4,4,0,0,0-.89-2.26A.92.92,0,0,0,334.71,405.93Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.48 408.74 337.14 408.74 337 391.72 344.35 391.72 344.48 408.74",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.21,407.89h8a.6.6,0,0,1,.6.5l1.23,6.53a1.11,1.11,0,0,1-1.11,1.3c-2.89,0-7.07-.21-10.7-.21-4.26,0-7.94.23-12.93.23-3,0-3.74-3.05-2.47-3.33,5.79-1.25,10.49-1.39,15.56-4.45A3.57,3.57,0,0,1,337.21,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.01 391.73 337.07 400.5 344.42 400.5 344.36 391.73 337.01 391.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.54,221.87s-3,54.93-2.94,77.33c0,23.3,11.8,99.6,11.8,99.6h12.44S343.6,323.86,345,301c1.49-25,8.71-79.11,8.71-79.11Z",
    style: {
      fill: "#ADB793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.18,393.84c-.06,0,.51,5.17.51,5.17h15.14l.58-4.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.22,158.37s-12.52,31.63-7.07,86.3h45.72c.48-6-4.3-58.26,2.52-86.68a101.36,101.36,0,0,0-13.1-1.66,145.28,145.28,0,0,0-16.7,0A74.84,74.84,0,0,0,328.22,158.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.75,187c-.68,5-1.24,10.71-1.6,17,8.88-8.16,11.92-28.49,11.92-28.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,173.43c-1.8,4.68-3.62,9.19-5.62,13.72s-4.07,9-6.4,13.48L320,202.3l-.46.84c-.19.34-.17.36-.69,1.23a9.78,9.78,0,0,1-3.61,3.36,10.76,10.76,0,0,1-3.91,1.18,16.46,16.46,0,0,1-5.6-.45,31,31,0,0,1-4.24-1.38,55.15,55.15,0,0,1-7.17-3.6c-1.13-.65-2.21-1.35-3.28-2S289,200,287.85,199.2l5.4-8.28a70.26,70.26,0,0,0,12.15,5.27,18.34,18.34,0,0,0,2.73.62,3.84,3.84,0,0,0,1.6,0c.06,0-.13-.06-.46.11a2.69,2.69,0,0,0-1,.88c-.21.35.06-.17.15-.37l.36-.79.72-1.57c1.9-4.24,3.66-8.63,5.37-13s3.37-8.93,4.9-13.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9,161.69c2.34,6.54-14.22,32.87-14.22,32.87l-9.82-9.73s2.51-8.27,5.82-18.23C322.94,156.81,335.67,155.44,337.9,161.69Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogin);
export default __webpack_public_path__ + "static/media/client-login.c852a6c9f7e5f660c4d569d067b58484.svg";
export { ForwardRef as ReactComponent };